@import 'vars';

.enter-mfa {
  display: flex;
  flex-direction: column;
  gap: 40px;
  height: fit-content;
  max-width: 450px;

  @media (max-width: 500px) {
    max-width: 90vw;
  }

  &--softphone {
    flex: 1;
    min-width: 100%;
    gap: 20px;
  }

  &__resend--disabled {
    color: $dark-grey !important;
    cursor: not-allowed;
    opacity: 100% !important;
    text-decoration: none;
  }

  &__cards {
    margin: 30px;
  }

  &__buttons {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__code-input {
    width: 100%;
    display: flex !important;
    gap: 10px;
  }

  &__link-box {
    width: 100%;
    display: flex;

    justify-content: center;
  }
}
